import { render, staticRenderFns } from "./smsAccount.vue?vue&type=template&id=5a52f25d&"
import script from "./smsAccount.vue?vue&type=script&lang=js&"
export * from "./smsAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports